import React from 'react';

import './style/checkBoxInput.scss';

const CheckboxInput = props => props.options.map(option => (
	<div className="form-check" key={option.value}>
		<label className="form-check-label" htmlFor={props.nameField + option.value}>
			<input
				className="form-check-input css-checkbox"
				type="checkbox"
				value={option.value}
				id={props.nameField + option.value}
				name={props.nameField}
				onChange={props.onChangeField}
				checked={(props.value.indexOf(option.value) !== -1)}
			/>
			<i />
			{option.label}
			{
				(typeof option.image !== 'undefined')
					? (
						<div className="checkbox-image">
							<img src={option.image} alt={props.label} />
						</div>
					)
					: ''
			}
		</label>
	</div>
));

export default CheckboxInput;
